export var ButtonGroupTypes;
(function (ButtonGroupTypes) {
    ButtonGroupTypes[ButtonGroupTypes["Button"] = 1] = "Button";
    ButtonGroupTypes[ButtonGroupTypes["Chip"] = 2] = "Chip";
})(ButtonGroupTypes || (ButtonGroupTypes = {}));
//# sourceMappingURL=ButtonGroupTypes.js.map